/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeLayers, Layers} from "./ElGordosRevengeLayers";
import {gsap, TimelineLite} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ShootableItem} from "./shooting/ShootableItem";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {BackgroundParticles} from "./particles/BackgroundParticles";
import {BackgroundBoostParticles} from "./particles/BackgroundBoostParticles";

export class ElGordosRevengeBackground extends PIXI.Container {

    private _backgroundMainSprite:PIXI.Sprite;
    private _backgroundMain:ShootableItem;
    private _bgAniContainer:PIXI.Container;
    private _bgSpine:PIXI.spine.Spine | null;
    private _reelFrameShooting:ShootableItem;
    private _reelBackground:PIXI.Container;
    private _reelForeground:PIXI.Container;
    private _dimmer:PIXI.Graphics;
    private _particles:BackgroundParticles;
    private _boostParticles:BackgroundBoostParticles;

    private _bgFireTl:TimelineLite | null;

    public isBoostLooping:boolean;

    private static _stageShakeTl:TimelineLite | null;

    private _currentMode:string;
    public get currentMode() {
        return this._currentMode;
    }

    constructor() {
        super();
        this.init();
    }

    private init() {
        this._particles = new BackgroundParticles();
        this._boostParticles = new BackgroundBoostParticles();

        this._dimmer = new PIXI.Graphics();
        // this._dimmer.beginFill(0x100403, 1);
        this._dimmer.beginFill(0xFFFFFF, 1);
        this._dimmer.drawRect(-840, -840, 1680, 1680);
        this._dimmer.endFill();
        this._dimmer.alpha = 0;
        this._dimmer.position.set(360, 360);

        this._backgroundMainSprite = new PIXI.Sprite();
        this._backgroundMainSprite.anchor.set(0.5, 0.5);
        this._backgroundMain = new ShootableItem({
                name : "background",
                holeScale : 0.8,
                view0 : this._backgroundMainSprite,
                soundPlayer : ElGordosRevengeSound.getDefaultGunShotEmptyTimeline
            }
        );
        this._backgroundMain.position.set(360, 360);
        ElGordosRevengeLayers.getLayer(Layers.BACKGROUND)?.addChild(this._backgroundMain);

        this._bgAniContainer = new PIXI.Container();
        ElGordosRevengeLayers.getLayer(Layers.BACKGROUND)?.addChild(this._bgAniContainer);

        this.updateMode(GameMode.NORMAL);

        this._reelBackground = new PIXI.Container();
        this._reelBackground.position.set(360, 360);
        ElGordosRevengeLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(this._reelBackground);
        const left = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/left")[0]);
        left.anchor.set(1, 0.5);
        left.position.set(-330, 55);
        this._reelBackground.addChild(left);
        const right = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/right")[0]);
        right.anchor.set(0, 0.5);
        right.position.set(332, 52);
        this._reelBackground.addChild(right);
        const ropes = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/ropes")[0]);
        ropes.anchor.set(0.5, 0.5);
        ropes.position.set(20, -156);
        this._reelBackground.addChild(ropes);

        this._reelForeground = new PIXI.Container();
        this._reelForeground.position.set(360, 360);
        ElGordosRevengeLayers.getLayer(Layers.FOREGROUND)?.addChild(this._reelForeground);
        const top = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/top")[0]);
        top.anchor.set(0.5);
        top.position.set(0, -256);
        this._reelForeground.addChild(top);
        const bottom = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/bottom")[0]);
        bottom.anchor.set(0.5);
        bottom.position.set(0, 382);
        this._reelForeground.addChild(bottom);
        const barRight = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/Extra_part")[0]);
        barRight.anchor.set(1, 0.5);
        barRight.position.set(380, 186);
        this._reelForeground.addChild(barRight);
        const barLeft = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("reelarea/Extra_part")[0]);
        barLeft.anchor.set(1, 0.5);
        barLeft.scale.x = -1;
        barLeft.position.set(-368, 186);
        this._reelForeground.addChild(barLeft);

        const reelForegroundShootingHoleContainer = new PIXI.Container();
        reelForegroundShootingHoleContainer.position.set(360, 360);
        ElGordosRevengeLayers.getLayer(Layers.FOREGROUND_HOLE)?.addChild(reelForegroundShootingHoleContainer);
        const reelFrameShootingView = new PIXI.Graphics();
        reelFrameShootingView.beginFill(0xff0000, 0.6);
        reelFrameShootingView.drawRect(-364, -168, 26, 436); // left bar
        reelFrameShootingView.drawRect(338, -168, 30, 440); // right bar
        // reelFrameShootingView.drawRect(-236, -286, 470, 30); // top bar
        reelFrameShootingView.drawRect(-366, -296, 140, 132); // top-left
        reelFrameShootingView.drawRect(226, -296, 140, 134); // top-right
        reelFrameShootingView.drawRect(-368, 176, 154, 20); // bottom bar left
        reelFrameShootingView.drawRect(226, 176, 154, 20); // bottom bar right
        reelFrameShootingView.drawRect(-372, 264, 750, 50); // bottom bar
        // logo
        reelFrameShootingView.moveTo(-236, -284);
        reelFrameShootingView.lineTo(-236, -254);
        reelFrameShootingView.lineTo(236, -254);
        reelFrameShootingView.lineTo(236, -284);
        reelFrameShootingView.arcTo(10, -362, -166, -306, 400);
        // reelFrameShootingView.arcTo(-80, -342, -180, -356, 340);
        reelFrameShootingView.endFill();
        reelFrameShootingView.alpha = 0; // TODO:
        this._reelFrameShooting = new ShootableItem({
            name : "reelFrame",
            target : reelForegroundShootingHoleContainer,
            holeScale : 1,
            view0 : reelFrameShootingView,
            soundPlayer : ElGordosRevengeSound.getDefaultGunShotWoodTimeline,
            holeGetter : () => ShootableItem.getDefaultWoodHole(1),
            sparkGetter : () => ShootableItem.getDefaultWoodSpark(1)
        });
        this._reelFrameShooting.position.set(360, 360);
        // ElGordosRevengeLayers.getLayer(Layers.FOREGROUND_HOLE)?.addChild(this._reelFrameShooting);
        ElGordosRevengeLayers.getLayer(Layers.BACKGROUND)?.addChild(this._reelFrameShooting);

        this._boostParticles.position.set(360, 360);
        ElGordosRevengeLayers.getLayer(Layers.BACKGROUND)?.addChild(this._boostParticles);
        this._particles.position.set(360, 360);
        ElGordosRevengeLayers.getLayer(Layers.BACKGROUND)?.addChild(this._particles);

        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {
        // TODO: check restore, mode, orientation
    }

    public onResize() {
        // TODO: check restore, mode, orientation
    }

    public dimScreen(alpha:number, duration:number, color?:number, layer?:StageLayer):TimelineLite {
        const tl = new TimelineLite();
        if(layer) {
            tl.add(() => {
                if(color != null) {
                    this._dimmer.tint = color;
                }
                layer.addChildAt(this._dimmer, 0);
            });
        }
        tl.add(gsap.to(this._dimmer, duration, {alpha : alpha}));
        return tl;
    }

    public updateMode(mode:string):void {
        if(this._currentMode === mode) {
            return;
        }

        this._currentMode = mode;
        let textureName = `${mode}_background`;
        this._backgroundMainSprite.texture = ElGordosRevenge.assetLoader.getTextures(textureName)[0];

        this._particles.playLoop(this._currentMode, BackgroundParticles.KEY_NORMAL);

        if(this._bgSpine) {
            this._bgSpine.state.setEmptyAnimations(0);
            this._bgSpine.parent?.removeChild(this._bgSpine);
            this._bgSpine.destroy();
            this._bgSpine = null;
        }

        this._bgSpine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset(`bg_${mode}`));
        this._bgSpine.autoUpdate = true;
        this._bgSpine.position.set(360, 360);
        this._bgAniContainer.addChild(this._bgSpine);
        this._bgSpine.state.setAnimation(0, "idle", true);
        if(mode !== GameMode.FREESPIN_SUPER) {
            this._bgSpine.state.setAnimation(1, "front_dust", true);
        }
    }

    public playBoostAnimation(loop:boolean, volume:number = 1):void {
        // this.resetBgFireTl();
        const tl = new TimelineLite();
        tl.add(() => {
            this._bgSpine!.state.setAnimation(2, "win_intro", false);
            this._boostParticles.play(this._currentMode);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.BG_EXPLOSION});
            if(loop) {
                this.isBoostLooping = true;
                ElGordosRevengeSound.playLoopEffect(ElGordosRevengeSound.BG_FIRE_LOOP, volume);
            }
        });
        if(loop) {
            tl.add(() => {
                if(this.isBoostLooping) {
                    this._bgSpine!.state.setAnimation(3, "win_loop", true);
                    this._particles.playLoop(this._currentMode, BackgroundParticles.KEY_WIN);
                }
            }, 0.3);
        }
        tl.add(() => {
            this._bgSpine!.state.setEmptyAnimation(2, 0);
        }, this._bgSpine!.spineData.findAnimation("win_intro").duration);

        tl.add(() => {this._bgFireTl = null;});
        // this._bgFireTl = tl;
    }

    public playIdleAnimation():void {
        // this.resetBgFireTl();
        if(this.isBoostLooping) {
            ElGordosRevengeSound.fadeAndStopLoopEffect({
                name : ElGordosRevengeSound.BG_FIRE_LOOP,
                to : 0,
                duration : 400
            });
        }

        this.isBoostLooping = false;
        this._bgSpine!.state.setEmptyAnimation(3, 0);
        this._particles.playLoop(this._currentMode, BackgroundParticles.KEY_NORMAL);
    }

    private resetBgFireTl():void {
        if(this._bgFireTl && this._bgFireTl.isActive()) {
            this._bgFireTl.paused();
            this._bgFireTl.kill();
        }
        this._bgFireTl = null;
    }

    public static moveStage(tl:TimelineLite):void {
        this.stopStageMove();
        tl.play();
        this._stageShakeTl = tl;
    }

    public static stopStageMove():void {
        if(this._stageShakeTl && this._stageShakeTl.isActive()) {
            this._stageShakeTl.progress(1);
        }
        this._stageShakeTl = null;
        ElGordosRevengeBackground.stage.position.set(0, 0);
    }

    public static get stage():PIXI.Container {
        return ElGordosRevengeLayers.getLayer(Layers.BACKGROUND)!.parent!;
    }

    public static shakeStageOnce(factor?:number, timeScale?:number):void {
        if(!factor) {
            factor = 1;
        }
        const tl = new TimelineLite({paused : true});
        tl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 16 * factor, y : -8 * factor, duration : 0.033}));
        tl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.267}));
        if(timeScale) {
            tl.timeScale(timeScale);
        }
        ElGordosRevengeBackground.moveStage(tl);
    }

    public static shakeStageChain(factor:number = 1):void {
        const shakeTl = new TimelineLite({paused : true});
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : -4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 4 * factor, y : -4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : -4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : -4 * factor, y : 4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : -4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : -4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 4 * factor, y : -4 * factor, duration : 0.066}));
        shakeTl.add(gsap.to(ElGordosRevengeBackground.stage, {x : 0, y : 0, duration : 0.066}));
        ElGordosRevengeBackground.moveStage(shakeTl);
    }
}